/**
 * Created by staffanrantzow on 15/03/16.
 */

/* @flow */
import React, {PropTypes } from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import { connect } from 'react-redux';
import { setInvoicePage } from 'redux/modules/scroll-positions/index';
import Spinner from 'components/spinner/spinner';
import SpinnerButton from 'components/spinner-button/spinner-button';
import GeneralError from 'components/general-error/general-error';
import { InvoiceService } from 'frilans-finans';
import InvoicesTable from './table-content/invoices-table';
import { ConfirmModal } from 'components';

export class Invoices extends React.Component {

  static propTypes = {
    dateFilter: PropTypes.object.isRequired,
    setInvoicePage: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      fetchingInitial: true,
      fetchingMore: false,
      fetchError: false,
      invoices: [],
      showPreview: false,
      previewInvoice: null,
      defaultSize: 10,
      size: 10,
      meta: {
        currentPage: 0
      },
      pendingRequest: null,
      renderConfirmModal: false,
      invoiceToDelete: null
    };

    this.fetchInvoices = this.fetchInvoices.bind(this);
    this.deleteInvoice = this.deleteInvoice.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.fetchInvoicesAgain = this.fetchInvoicesAgain.bind(this);
    this.removeInvoiceFromState = this.removeInvoiceFromState.bind(this);
  }

  componentWillUnmount () {
    if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
      this.state.pendingRequest.cancel();
    }
  }

  componentDidMount () {
    this.fetchInvoices();
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.dateFilter.startDate !== this.props.dateFilter.startDate ||
      nextProps.dateFilter.endDate !== this.props.dateFilter.endDate) {
      this.props = nextProps;

      this.fetchInvoicesAgain();
    }
  }

  fetchInvoices () {
    this.setState({
      fetchingMore: true
    });

    const userId = +this.props.user.id;

    let pendingRequest = InvoiceService
      .get(userId, this.props.dateFilter, this.state.meta.currentPage + 1, 0, null, this.state.size);

    pendingRequest.promise
      .then(this.handleResponse.bind(this))
      .catch(error => {
        if (error.response !== undefined) {
          this.setState({
            fetchError: true
          });
        }
      });

    this.setState({
      pendingRequest: pendingRequest
    });
  }

  fetchInvoicesAgain () {
    this.setState({
      fetchingMore: true,
      invoices: [],
      fetchingInitial: true,
      meta: {
        currentPage: 0
      }
    }, this.fetchInvoices);
  }

  handleResponse (response) {
    this.setState({
      fetchingMore: false,
      fetchingInitial: false,
      fetchError: false,
      invoiceServiceGet: null,
      size: this.state.defaultSize,
      invoices: this.state.invoices.concat(response.collection),
      meta: response.meta
    }, this.scrollDown);
  }

  removeInvoiceFromState (id) {
    this.setState({
      invoices: this.state.invoices.filter((invoice) => invoice.id !== id)
    });
  }

  deleteInvoice (invoice) {
    this.setState({
      renderConfirmModal: true,
      invoiceToDelete: invoice
    });
  }

  closeModal (confirm) {
    if (confirm) {
      InvoiceService.delete(this.state.invoiceToDelete.id)
        .then(this.removeInvoiceFromState(this.state.invoiceToDelete.id))
        .catch(() => {
          this.setState({
            fetchError: true
          });
        });

      this.setState({
        renderConfirmModal: false,
        invoiceToDelete: null
      });
    } else {
      this.setState({
        renderConfirmModal: false,
        invoiceToDelete: null
      });
    }
  }

  renderConfirmModal () {
    if (this.state.renderConfirmModal) {
      return (
        <ConfirmModal
          callback={this.closeModal}
          message={proxyCounterpart('DELETE_INVOICE')}
        />
      );
    }
  }

  renderLoader () {
    return (
      <div className='loader-wrapper'>
        <Spinner />
      </div>
    );
  }

  renderNoResult () {
    return (
      <p className='info'>
        <Translate content='NO_INVOICES'/>
      </p>
    );
  }

  renderTableWrapper () {
    return (
      <div>
        <InvoicesTable invoices={this.state.invoices} />
        {this.renderShowMoreBtn()}
      </div>
    );
  }

  renderShowMoreBtn () {
    if (this.state.meta.currentPage < this.state.meta.totalPages && !this.state.fetchingInitial) {
      return (
        <div className='show-more-btn-wrapper'>
          <SpinnerButton text={proxyCounterpart('SHOW_MORE')} graySpinner='true'
            loading={this.state.fetchingMore} classes='btn white show-more' callback={this.fetchInvoices}/>
        </div>
      );
    }

    return false;
  }

  getContent () {
    if (this.state.fetchError) {
      return (<GeneralError />);
    }
    if (this.state.fetchingInitial) {
      return this.renderLoader();
    }
    if (this.state.invoices.length === 0) {
      return this.renderNoResult();
    }

    return this.renderTableWrapper();
  }

  render () {
    var content = this.getContent();

    return (
      <div className='invoices'>
        {content}
        {this.renderConfirmModal()}
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    dateFilter: state.filters.dateFilter,
    user: state.user
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setInvoicePage: (invoice) => dispatch(setInvoicePage(invoice))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Invoices);



/** WEBPACK FOOTER **
 ** ./src/views/economy-view/invoices/invoices.js
 **/